import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';

import { IEvl0107MState, EvaluationItem, ProjectInfo, AlertInfo } from '../../models/evl/evl0107m_model';

const initialState: IEvl0107MState = {
  pmScores: {},
  projectInfo: {
    pjNm: '',
    userNm: '',
    deptNm: '',
  },
  evaluationData: [],
  alertInfo: null,
  isSubmitted: false,
  pmSubYn: '',
  unevaluatedKeys: [],
};

export const Evl0107m_Slice = createSlice({
  name: "evl0107m_Slice",
  initialState: initialState,
  reducers: {
    initState: (state) => {
      return cloneDeep(initialState);
    },
    setPmScores: (state, action: PayloadAction<Record<string, string>>) => {
      state.pmScores = action.payload;
    },
    setProjectInfo: (state, action: PayloadAction<ProjectInfo>) => {
      state.projectInfo = action.payload;
    },
    setEvaluationData: (state, action: PayloadAction<EvaluationItem[]>) => {
      state.evaluationData = action.payload;
    },
    setAlertInfo: (state, action: PayloadAction<AlertInfo | null>) => {
      state.alertInfo = action.payload;
    },
    setIsSubmitted: (state, action: PayloadAction<boolean>) => {
      state.isSubmitted = action.payload;
    },
    setPmSubYn: (state, action: PayloadAction<string>) => {
      state.pmSubYn = action.payload;
    },
    setUnevaluatedKeys: (state, action: PayloadAction<string[]>) => {
      state.unevaluatedKeys = action.payload;
    },
  },
});

export default Evl0107m_Slice.reducer;
export const Evl0107mAction = Evl0107m_Slice.actions;
export const Evl0107mReducer = Evl0107m_Slice.reducer;